<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">保戶失聯原因</h3>
        </div>
        <div class="modal-body send-modal-body" style="min-height:220px;">
            <div class="font-weight-bold">保戶失聯原因為何?  (必填)</div>
            <div class="form-group mt-3">
                <div class="radio radio-inline">
                    <input type="radio" v-model="missingReason" name="missing-type-1" id="missing-type-1" value="5">
                    <label for="missing-type-1">遷址不明</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="missingReason" name="missing-type-2" id="missing-type-2" value="6">
                    <label for="missing-type-2">查無此址</label>
                </div>
                <div class="radio radio-inline">
                    <input type="radio" v-model="missingReason" name="missing-type-3" id="missing-type-3" value="10">
                    <label for="missing-type-3">電話不正確</label>
                </div>
            </div>
            <div class="action text-right">
              <a v-if="isShowCancel" @click.stop.prevent="$emit('cancel')" class="btn btn-primary">
                取消失聯
              </a>
              <a @click.stop.prevent="submit()" class="btn btn-primary">
                儲存
              </a>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'

export default {
  name: 'MissingModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    contact: {
      type: String,
      default: '',
    },
    isShowCancel: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    open (val) {
      if(val){
        this.missingReason = this.contact
        this.registerHanlink()  // for hard word
      }
    }
  },
  data() {
    return {
        missingReason: ''
    }
  },
  methods: {
      submit() {
          this.$emit('submit', this.missingReason);
      }
  },
  computed: {
  }
}
</script>
